import { Typography } from '@mui/material';
import { DeleteAlarmRule } from '../../types/DeleteAlarmRule';
import {
  CONFIRMATION_TEXT_DELETE_ALARM_RULE_DIALOG,
  CONFIRMATION_TEXT_DELETE_ALARM_RULE_DIALOG_EXPLANATION,
  CONFIRMATION_TEXT_DELETE_ALARM_EVENT,
} from '../../config';

type AlertDialogDeleteAlarmRuleContentProps = {
  deleteAlarmRule: DeleteAlarmRule;
  isAlarmRule: boolean;
};

export const AlertDialogDeleteAlarmRuleContentContent = ({
  deleteAlarmRule,
  isAlarmRule,
}: AlertDialogDeleteAlarmRuleContentProps) => (
  <>
    {isAlarmRule ? (
      <>
        <Typography color="text.secondary">
          {CONFIRMATION_TEXT_DELETE_ALARM_RULE_DIALOG} <strong>{deleteAlarmRule.title}</strong>?
        </Typography>
        <br />
        <Typography color="text.secondary">
          {CONFIRMATION_TEXT_DELETE_ALARM_RULE_DIALOG_EXPLANATION}
        </Typography>
      </>
    ) : (
      <Typography color="text.secondary">{CONFIRMATION_TEXT_DELETE_ALARM_EVENT}</Typography>
    )}
  </>
);
